
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ShippingItemsGrid extends Serenity.EntityGrid<ShippingItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ShippingItems'; }
        protected getDialogType() { return ShippingItemsDialog; }
        protected getIdProperty() { return ShippingItemsRow.idProperty; }
        protected getInsertPermission() { return ShippingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingItemsRow.localTextPrefix; }
        protected getService() { return ShippingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        
    } 
} 